import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { initFirebase } from './lib/firebase';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Defer the firebase chunk fetches so they don't race the route chunks at boot.
const FIREBASE_INIT_FALLBACK_MS = 2000;
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(() => initFirebase());
} else {
  setTimeout(initFirebase, FIREBASE_INIT_FALLBACK_MS);
}
